import { GET_LOGIN_RECORDS,GET_LOGIN_RECORDS_BY_ID, SORT_LOGIN_RECORDS } from '../actions/types';
import _ from 'lodash';

const INITIAL_STATE = {
    list: [],
    selectedLoginRecords: {
        name: '',
        email: '',
    },
    sortColumn: 'name',
    sortDirection: 'ascending',
    LoginRecordsModalOpen: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_LOGIN_RECORDS:
            console.log(action.payload);

            return {
                ...state,
                list: action.payload,
                LoginRecordsModalOpen: false
            }

        case GET_LOGIN_RECORDS_BY_ID:
            let loginrecords = state.list.find((loginrecords) => loginrecords._id === action.payload);
            return {
                ...state,
                selectedLoginRecords: loginrecords,
                LoginRecordsModalOpen: true
            }

        case SORT_LOGIN_RECORDS:
            let sorted = null;
            let sort_column = action.payload;
            let direction = 'ascending';
            if (state.sortColumn !== sort_column) {
                console.log('Sorting by ' + sort_column);
                sorted = _.sortBy(state.list, [sort_column]);
            } else {
                sorted = state.list.reverse();
                console.log(sorted);
                direction = (state.sortDirection === 'ascending') ? 'descending' : 'ascending';
                console.log('Sorting in ' + direction);
            }

            return {
                ...state,
                list: sorted,
                sortColumn: sort_column,
                sortDirection: direction
            }

        default:
            return state;
    }
}